// extracted by mini-css-extract-plugin
export default {"cover":"DbQaibTeeSdsIgVpw8ug","title":"uQsFc97Dn7pXQISr2mbh","stats":"hDz0lUhMiDSIC0uMfka7","planners":"IY2PsdFxi5HFi010f2Dc"};